import React, { useEffect, useState } from "react";
import HeaderCustom from "../../components/header/HeaderCustom";
import { ButtonStyleAzul, ButtonStyleWhite, CentrarDiv, CustomBackdrop, DivBackgroundDasboard, MaxDiv, PaperStyle, TEXT_COLOR_AZUL_OSCURO, TEXT_COLOR_CELESTE, TypographyStyleSecundary } from "../../styles/Styles";
import { Alert, Backdrop, Button, CircularProgress, Container, CssBaseline, IconButton, InputAdornment, Paper, Snackbar, Typography, ListItem, ListItemButton, ListItemText, TextField } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setToken } from "../../redux/actions/action";
import { ButtonFlotante } from "../../components/botonQr/ButtonFlotante";

const MisDatosPage = (props) => {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [open, setOpen] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [mensaje, setMensaje] = useState('');
    const [cargando, setCargando] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [titleSelected, setTitleSelected] = useState(false);
    const [indexSelected, setIndexSelected] = useState(0);
    const [dataInputs, setDataInputs] = useState([
        {
            title: 'Usuario',
            type: 'text',
            titlesecundary: 'Sin definir',
            active: true,
            code: 'user'
        },
        {
            title: 'Código de Comercio',
            type: 'number',
            titlesecundary: 'Sin definir',
            active: true,
            code: 'codeComercio'
        },
        {
            title: 'Contraseña',
            type: 'password',
            titlesecundary: 'Sin definir',
            active: false,
            code: 'password'
        },
        {
            title: 'Razón Social',
            type: 'text',
            titlesecundary: 'Sin definir',
            active: true,
            code: 'razonSocial'
        },
        {
            title: 'Nombre Fantasía',
            type: 'text',
            titlesecundary: 'Sin definir',
            active: true,
            code: 'nombreFantasia'
        }
    ]);

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log('satate', stateToken);

    let history = useNavigate();

    const dispatch = useDispatch();


    //seteo los datos del usuario del stateToken
    useEffect(() => {
        console.log('actualizado,', dataInputs);
        handleSetearDatos();
    }, [stateToken]);

    const handleSetearDatos = () => {

        setDataInputs(dataInputs.map((item, index) => {
            if (item.code === 'user') {
                item.titlesecundary = stateToken ? stateToken.usuarioNombre.toUpperCase() : 'Sin definir';
            }
            if (item.code === 'codeComercio') {
                item.titlesecundary = stateToken ? stateToken.codeComercio : 'Sin definir';
            }
            if (item.code === 'razonSocial') {
                item.titlesecundary = stateToken ? stateToken.razonSocial : 'Sin definir';
            }
            if (item.code === 'nombreFantasia') {
                item.titlesecundary = stateToken ? stateToken.descripcion : 'Sin definir'
            }
            return item;
        }));
    }


    //--------------------------------cerrar sesion de login
    const closeLogin = () => {
        setCargando(true);
        setTimeout(() => {
            localStorage.removeItem('dataUser');
            dispatch(setToken(null));
            setCargando(false);
            history('/');
        }, 2000);
    }

     //reseterar al inicio, sin poder volver atras
     const handleHomeReset = () => {
        history('/home', { replace: true });
    };

    return (
        <div>
            <HeaderCustom title="Perfil">
                <MaxDiv>
                    {/* <TypographyStyleSecundary component="h5" variant="h5" align='center' style={{ marginBottom: '20px' }}>
                        Mis Datos
                    </TypographyStyleSecundary> */}

                    {/* <Container component="main" maxWidth="xs">
                        <CssBaseline /> */}


                    <PaperStyle>
                        <TypographyStyleSecundary component="h5" variant="h5" align='center' style={{  }}>
                            Mis Datos
                        </TypographyStyleSecundary>

                        {dataInputs.map((item, index) => (
                            item.active &&
                            <ListItem key={index}>
                                <ListItemText
                                    primary={item.title}
                                    // secondary={item.titlesecundary === '' ? 'Sin definir' : item.titlesecundary && item.titlesecundary.trim() === '' ? 'Sin definir' : item.titlesecundary}
                                    // secondary={handleValidarTitleSecundary(item, index)}
                                    secondary={item.titlesecundary}
                                    primaryTypographyProps={{ color: TEXT_COLOR_CELESTE }}
                                    secondaryTypographyProps={{ color: TEXT_COLOR_AZUL_OSCURO }}
                                />
                            </ListItem>
                        ))}

                    </PaperStyle>

                    <div style={{
                        marginTop: '20px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'

                    }}>
                        <div style={{width: '45%'}}>
                            <ButtonStyleWhite
                                variant="contained"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: '10px',
                                    color: '#333',
                                }}
                                fullWidth
                                onClick={handleHomeReset}
                            >
                                Cancelar
                            </ButtonStyleWhite>
                        </div>

                        <div style={{width: '45%'}}>
                            <ButtonStyleAzul
                                variant="contained"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: '10px'
                                }}
                                fullWidth
                                onClick={closeLogin}
                            >
                                Desconectar
                            </ButtonStyleAzul>
                        </div>
                    </div>
                    {/* </Container> */}

                    {/*agregar boton flotante*/}
                    <ButtonFlotante />
                </MaxDiv>
            </HeaderCustom>

            <CustomBackdrop open={cargando}>
                <CircularProgress color="inherit" />
            </CustomBackdrop>
        </div>
    )
}

export default MisDatosPage;